export default "__VITE_ASSET__b72c770a__"